import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    errorBlank: String,
    errorTooLong: String
  };

  connect() {
    this.errorPlaceholder = this.element.querySelector(".js-error-placeholder");
    this.errorContainer = this.element.querySelector(".new-post__errors");
    if (!this.errorContainer) {
      this.errorContainer = this.createErrorContainer();
    }
  }

  validate(event) {
    const errors = this.collectErrors();

    if (errors.length > 0) {
      event.preventDefault();
      event.stopPropagation();
      this.displayErrors(errors);
      return false;
    }

    this.clearErrors();
    return true;
  }

  collectErrors() {
    const errors = [];

    // Get content from the rhino-editor
    const editor = this.element.querySelector("rhino-editor");
    const hiddenInput = this.element.querySelector("input[name*='[content]']");

    if (editor && hiddenInput) {
      const content = hiddenInput.value || "";
      const plainText = this.stripHtmlTags(content).trim();

      if (plainText.length === 0) {
        errors.push(this.errorBlankValue);
      } else if (plainText.length > 3000) {
        errors.push(this.errorTooLongValue);
      }
    }

    return errors;
  }

  displayErrors(errors) {
    if (!this.errorContainer) {
      this.errorContainer = this.createErrorContainer();
    }

    this.errorContainer.innerHTML = `
      <ul>
        ${errors.map(error => `<li class="body--medium">${error}</li>`).join("")}
      </ul>
    `;

    this.errorContainer.style.display = "block";

    // Scroll to errors
    this.errorContainer.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }

  clearErrors() {
    if (this.errorContainer) {
      this.errorContainer.innerHTML = "";
      this.errorContainer.style.display = "none";
    }
  }

  createErrorContainer() {
    const container = document.createElement("div");
    container.className = "new-post__errors";
    container.style.display = "none";

    // Insert into the error placeholder
    if (this.errorPlaceholder) {
      this.errorPlaceholder.appendChild(container);
    } else {
      // Fallback: insert at the beginning of the form
      this.element.insertBefore(container, this.element.firstChild);
    }

    return container;
  }

  stripHtmlTags(html) {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  }
}